import { render, staticRenderFns } from "./PhotoSuggestionsLayer.vue?vue&type=template&id=3858ef68&scoped=true"
import script from "./PhotoSuggestionsLayer.vue?vue&type=script&lang=js"
export * from "./PhotoSuggestionsLayer.vue?vue&type=script&lang=js"
import style0 from "./PhotoSuggestionsLayer.vue?vue&type=style&index=0&id=3858ef68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3858ef68",
  null
  
)

export default component.exports